// src/api.js
// Small helper for JSON API calls used by the admin UI.
// - Supports optional token auth (sends both Authorization and x-admin-token)
// - Sends cookies (credentials: 'include') for backends that use sessions
export default async function api(path, opts = {}) {
  const {
    method = "GET",
    body,
    token,
    headers = {},
  } = opts;

  const baseURL = process.env.REACT_APP_API_URL || "";
  const url = path.startsWith("http")
    ? path
    : `${baseURL}${path.startsWith("/") ? "" : "/"}${path}`;

  const authHeaders = token
    ? {
        Authorization: `Bearer ${token}`,
        "x-admin-token": token,
      }
    : {};

  const isForm = typeof FormData !== "undefined" && body instanceof FormData;

  const res = await fetch(url, {
    method,
    headers: {
      ...(isForm ? {} : body ? { "Content-Type": "application/json" } : {}),
      ...authHeaders,
      ...headers,
    },
    body: body ? (isForm ? body : JSON.stringify(body)) : undefined,
    credentials: "include",
  });

  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text || null;
  }

  if (!res.ok) {
    const msg =
      (data && typeof data === "object" && (data.error || data.message)) ||
      (typeof data === "string" && data) ||
      `Request failed (${res.status})`;
    const err = new Error(msg);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}
